export default "__VITE_PUBLIC_ASSET__8f3531c8__"